module.exports = __webpack_public_path__ + "static/img/4.a2d0b71c.png";